import { HandlingTypeEnum } from './enums/handling-type.enum';
import { Offer } from './offer.model';

export interface IOfferHandlingType {
  id?: number;
  activated?: boolean | null;
  type?: HandlingTypeEnum | null;
  minWidth?: number | null;
  minLength?: number | null;
  minHeight?: number | null;
  maxWidth?: number | null;
  maxLength?: number | null;
  maxHeight?: number | null;
  maxVolume?: number | null;
  minQuantity?: number | null;
  maxQuantity?: number | null;
  minOtherQuantity?: number | null;
  maxOtherQuantity?: number | null;
  minWeight?: number | null;
  maxWeight?: number | null;
  maxWeightWithTailgate?: number | null;
  offer?: Offer | null;
}

export class OfferHandlingType implements IOfferHandlingType {
  constructor(
    public id?: number,
    public activated?: boolean | null,
    public type?: HandlingTypeEnum | null,
    public minWidth?: number | null,
    public minLength?: number | null,
    public minHeight?: number | null,
    public maxWidth?: number | null,
    public maxLength?: number | null,
    public maxHeight?: number | null,
    public maxVolume?: number | null,
    public minQuantity?: number | null,
    public maxQuantity?: number | null,
    public minOtherQuantity?: number | null,
    public maxOtherQuantity?: number | null,
    public minWeight?: number | null,
    public maxWeight?: number | null,
    public maxWeightWithTailgate?: number | null,
    public offer?: Offer | null
  ) {
    this.activated = this.activated ?? false;
  }
}

export function getOfferHandlingTypeIdentifier(offerHandlingType: IOfferHandlingType): number | undefined {
  return offerHandlingType.id;
}
